import type { Theme } from '@sky-distribution/react-commons-ui/lib/Theme/utils/theme.type';
import { TENANT_NAME } from '../tenants';
import { themes } from '../themes';

export const useTheme = (): Theme => themes.find((t) => t.name === TENANT_NAME)!.config;
